/**
 * Tiny invalidation bus. After any CRM write, call invalidateCrm(...scopes);
 * every mounted useCrmQuery subscribed to one of those scopes refetches.
 */

/** @typedef {'contacts'|'contact'|'accounts'|'deals'|'forecast'|'summary'|'followups'|'activities'|'tasks'|'views'} CrmScope */

/** @type {Set<(scopes: CrmScope[]) => void>} */
const listeners = new Set()

/** @param {CrmScope[]} scopes */
export const invalidateCrm = (...scopes) => {
    listeners.forEach(listener => listener(scopes))
}

/** @param {(scopes: CrmScope[]) => void} listener @returns {() => void} unsubscribe */
export const subscribeCrm = listener => {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

/** What every write affects. Contacts/deals/accounts changes also move the KPI tiles and bell. */
export const ALL_CRM_SCOPES = [
    'contacts',
    'contact',
    'accounts',
    'deals',
    'forecast',
    'summary',
    'followups',
    'activities',
    'tasks',
]
